import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { colors, fontSize } from 'styles/theme';
import { notLast } from 'styles/utils';

import Text from '../Text/Text';

const postMetadataCss = css`
  margin-bottom: 20px;
  font-size: ${fontSize.xs};
  color: ${colors.brownGray};
`;

const metadataAttributeCss = css`
  ${notLast} {
    ::after {
      content: ' • ';
    }
  }
`;

function PostMetadata({ isVideo, length, lengthDescribed, reviewer }) {
  return (
    <Text isMui={false} css={postMetadataCss}>
      {/* Reviewer */}
      {reviewer && (
        <span css={metadataAttributeCss}>Reviewed by {reviewer}</span>
      )}

      {/* Length */}
      {lengthDescribed && (
        <span css={metadataAttributeCss}>
          {isVideo ? length : lengthDescribed}
        </span>
      )}
    </Text>
  );
}

PostMetadata.propTypes = {
  isVideo: PropTypes.bool,
  length: PropTypes.string,
  lengthDescribed: PropTypes.string,
  reviewer: PropTypes.string,
};

export default PostMetadata;
